import { RemovingDocumentErrorCode } from "@common/constants/financial-documents";
import { z } from "zod";

export const RemovingDocumentUsedInReconciliationErrorSchema = z.object({
    code: z.literal(
        RemovingDocumentErrorCode.REMOVING_DOCUMENT_USED_IN_RECONCILIATION,
    ),
    message: z.string(),
    documentNames: z.array(z.string()),
});

export type RemovingDocumentUsedInReconciliationError = z.infer<
    typeof RemovingDocumentUsedInReconciliationErrorSchema
>;
